import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_FINANCEIRO = [
  {
    module: 'FIN_CONTAS_RECEBER',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'created_at'
      },
      {
        active: true,
        removable: false,
        field: 'conta_receber.parceiro.nome_razao_social'
      },
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'vencimento'
      },
      {
        field: 'valor',
        active: true,
        removable: true
      },
      {
        active: true,
        removable: true,
        field: 'forma_pagto.descricao'
      },
      {
        field: 'dias_atraso',
        active: true,
        removable: true
      },
      {
        field: 'valor_juros',
        active: true,
        removable: true
      },
      {
        field: 'desconto',
        active: true,
        removable: true
      },
      {
        active: true,
        removable: true,
        field: 'pagamentos.data_hora'
      },
      {
        field: 'valor_total_pagtos',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar_com_juros',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'FIN_CONTAS_PAGAR',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'created_at'
      },
      {
        active: true,
        removable: false,
        field: 'conta_pagar.fornecedor.parceiro.nome_razao_social'
      },
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'vencimento'
      },
      {
        field: 'valor',
        active: true,
        removable: true
      },
      {
        active: true,
        removable: true,
        field: 'forma_pagto.descricao'
      },
      {
        field: 'dias_atraso',
        active: true,
        removable: true
      },
      {
        field: 'valor_juros',
        active: true,
        removable: true
      },
      {
        field: 'desconto',
        active: true,
        removable: true
      },
      {
        active: true,
        removable: true,
        field: 'pagamentos.data_hora'
      },
      {
        field: 'valor_total_pagtos',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar',
        active: true,
        removable: true
      },
      {
        field: 'valor_total_ha_pagar_com_juros',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PORTADOR',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'padrao'
      },
      {
        active: true,
        removable: true,
        field: 'saldo_inicial'
      },
      {
        active: true,
        removable: true,
        field: 'saldo'
      }
    ]
  },
  {
    module: 'FIN_MOV_FINANCEIRA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'numero'
      },
      {
        active: true,
        removable: true,
        field: 'portador.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'observacao'
      },
      {
        active: true,
        removable: false,
        field: 'nome_parceiro'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'data_movimento'
      },
      {
        active: true,
        removable: true,
        field: 'is_conciliado'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  }
] as IColunasSettingsUser[];
